<div class="container-spinner">
  <div class="spinner"></div>
  <span class="compteur">
    @if (appInfo?.logoUrl != null) {
      <img [src]="appInfo.logoUrl" />
    }
  </span>
</div>
